<template>
  <div class="layout-main">
    <the-navbar />
    <div class="router-wrapper">
      <router-view />
    </div>
    <the-footer />
    <biew-badge />
  </div>
</template>

<script>
import BiewBadge from "@/components/BiewBadge";
import TheFooter from "@/components/TheFooter";
import TheNavbar from "@/components/TheNavbar";

export default {
  name: "Main",
  components: {
    BiewBadge,
    TheFooter,
    TheNavbar
  }
};
</script>

<style lang="scss" scoped>
.layout-main {
  background-color: #f4f4f4;
}

.router-wrapper {
  box-sizing: border-box;
  padding: 30px;
  min-height: 70vh;
}
</style>
